
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel, } from "@dev/hc-components";
import IBlock2Others from "@/module/main/model/applicationForm/IBlock2Others";
import Cohabitation from "@/module/main/dto/customer/CohabitationEnum";
import HousingTenure from "@/module/main/dto/customer/HousingTenureEnum";
import Education from "@/module/main/dto/customer/EducationEnum";
import { EnumUtil } from "@/app";
import Nationality from "@/module/main/dto/customer/NationalityEnum";
import PrimaryDocumentType from "@/module/main/dto/customer/PrimaryDocumentTypeEnum";

@Component
export default class Block2Others extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock2Others;

    protected pageName: string = "block2-others";

    private get cohabitationData(): object[] {
        return EnumUtil.createSelectDataFromEnum(Cohabitation, "Cohabitation", true);
    }

    private get housingTenureData(): object[] {
        return EnumUtil.createSelectDataFromEnum(HousingTenure, "HousingTenure", true);
    }

    private get educationData(): object[] {
        return EnumUtil.createSelectDataFromEnum(Education, "Education", true);
    }

    private get nationalityData(): object[] {
        return EnumUtil.createSelectDataFromEnum(Nationality, "Nationality", true);
    }

    private get primaryDocumentTypeData(): object[] {
        return EnumUtil.createSelectDataFromEnum(PrimaryDocumentType, "PrimaryDocumentType", true);
    }
}
